export const FORM_CONTENT_TYPE = { "Content-Type": "application/x-www-form-urlencoded" };
export const ROOT_URL = "//bjapi.onlive.vn/api";
export const PLAY_HTTPS_URL = "https://play.onlive.vn";
